var IFrameVideo = require('./IFrameVideo');

module.exports = IFrameVideo;
